import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Flame } from "lucide-react";

/**
 * Homepage self-select chips. Pulls the biggest county×trade supply gaps from
 * /api/public/hot-gaps and turns each into a tap-to-signup chip. Only renders
 * when there's real live demand — otherwise gets out of the way.
 */
export default function TradeChips() {
  const [chips, setChips] = useState([]);

  useEffect(() => {
    let alive = true;
    api
      .get("/public/hot-gaps")
      .then((r) => alive && setChips(r.data?.chips || []))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!chips.length) return null;

  return (
    <div data-testid="trade-chips" className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <Flame className="w-3.5 h-3.5 text-amber-500" />
        <span className="text-amber-500 text-[10px] font-bold tracking-[0.3em] uppercase">
          Contractors are looking for
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        {chips.map((c) => (
          <Link
            key={`${c.trade}-${c.county}`}
            data-testid={`chip-${c.trade}-${c.county}`}
            to={`/get-work?trade=${encodeURIComponent(c.trade)}&county=${encodeURIComponent(c.county)}`}
            className="group inline-flex items-center gap-2 border border-amber-500/60 bg-amber-500/5 hover:bg-amber-500 hover:text-neutral-950 text-amber-200 px-3 py-1.5 text-xs uppercase tracking-widest transition-colors"
          >
            <span className="font-bold text-amber-500 group-hover:text-neutral-950">
              {c.trade}
            </span>
            <span className="opacity-70">in</span>
            <span>{c.county}</span>
            <span className="ml-1 inline-flex items-center justify-center min-w-[20px] h-[18px] px-1 bg-amber-500 text-neutral-950 text-[10px] font-bold group-hover:bg-neutral-950 group-hover:text-amber-500">
              {c.jobs}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
